import React from 'react'
import styles from './TopBarContent.module.scss'

interface TopBarContentProps {
  children: React.ReactNode
  className?: never
}

export const TopBarContent: React.FC<TopBarContentProps> = ({ children }) => (
  <div className={styles.content}>{children}</div>
)
